const FeedbackFactory = window.FeedbackFactory = module.exports = {

  version: __VER__,

  options: {
    sources: ".",
    url: "feedback.php",
    extraKey: "altKey",
    key: 66
  },

  data: {},

  scripts: [],

  html2canvasOptions: {
    //allowTaint: true,
    letterRendering: true,
    //background: "repeating-linear-gradient(-45deg, rgb(255, 210, 47), rgb(255, 210, 47) 25px, rgb(0, 0, 0) 25px, rgb(0, 0, 0) 50px)"
  },

  setOption(name, value) {
    if (this.options.hasOwnProperty(name)) {
      FeedbackFactory.options[name] = value;
    } else {
      console.error(`Опция "${name}" не поддерживается`);
    }
    return FeedbackFactory;
  },


  setOptions(options) {
    for (let key in options) {
      if (options.hasOwnProperty(key)) {
        this.setOption(key, options[key]);
      }
    }
    return FeedbackFactory;
  },


  setData(key, value) {
    FeedbackFactory.data[key] = value;
    return FeedbackFactory;
  },


  addScript(url) {
    FeedbackFactory.scripts.push(url);
    return FeedbackFactory;
  },

  init() {
    addEventListener('keydown', (e) => {
      if (e[this.options.extraKey] && e.keyCode == this.options.key) {
        FeedbackFactory.run();
      }
    });
  },

  run() {
    if (window.Feedback) {
      init();
      return;
    }

    let length = 0;

    loadJS(FeedbackFactory.options.sources + '/feedback.js?v' + FeedbackFactory.version, done);
    FeedbackFactory.scripts.forEach((url) => {
      loadJS(url, done);
    });

    function done() {
      length--;
      if (length === 0) {
        init();
      }
    }

    function loadJS(url, callback) {
      length++;
      let script = document.createElement('script');
      script.onload = callback;
      script.onerror = callback;
      script.async = true;
      script.src = url;
      (document.head || document.body).appendChild(script);
    }

    function init() {
      try {
        Feedback.init({
          options: FeedbackFactory.options,
          html2canvasOptions: FeedbackFactory.html2canvasOptions,
          data: FeedbackFactory.data
        });
      } catch (e) {
        console.error(e);
      }
    }
  }

};


FeedbackFactory.init();



/** WEBPACK FOOTER **
 ** ./FeedbackFactory.js
 **/